import React from 'react'

import T from 'components/FormattedMessage'
import Button from 'components/Button'

interface Props {
  className?: string
}

const NavigateToStoreButton: React.SFC<Props> = ({ className }) => (
  <Button
    to={`/store/premium-accounts`}
    color="accent"
    variant="contained"
    className={className}
  >
    <T id="store_promo_button" />
  </Button>
)

export default NavigateToStoreButton
